"use client";

import { useEffect, useMemo } from "react";
import dynamic from "next/dynamic";

import { localeDirection } from "@/src/shared/i18n/direction";
import { useLocale } from "@smartmanager/shell-ui/shared/i18n/i18nContext";
import { normalizeLanguage } from "@/app/components/i18n/normalizeLanguage";

// Saved-preference sync needs the full app store; keep it out of the JS every
// page downloads before first paint.
const LocalePreferencePersistence = dynamic(
  () => import("@/app/components/i18n/LocalePreferencePersistence"),
  { ssr: false }
);

export default function LocalePreferenceSync() {
  const locale = useLocale();
  const normalizedLocale = useMemo(() => normalizeLanguage(locale), [locale]);

  // The server renders lang/dir for its locale; the desktop shell switches
  // languages client-side, so keep both attributes aligned after a change and
  // let Arabic and other RTL languages reflow immediately.
  useEffect(() => {
    document.documentElement.lang = normalizedLocale;
    document.documentElement.dir = localeDirection(normalizedLocale);
  }, [normalizedLocale]);

  return <LocalePreferencePersistence />;
}
